export default "__VITE_ASSET__b8bc05b7__"